<template>
  <div class="progress-bar">
    <div class="progress-track">
      <div class="progress-fill" :style="{ width: `${progress}%` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100,
    },
  },
};
</script>

<style scoped>
.progress-bar {
  width: 72.5%;
  height: 10px;
  background-size: 100% 100%;
  padding: 10px 0;
}

.progress-track {
  width: 100%;
  height: 8px;
  background: #e8eef4;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: url("../../../assets/game/images/unit-bar-progress.png");
  border-radius: 4px;
}

/* 添加发光效果 */
.progress-fill::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
